// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-16a0fa5e] .CodeMirror{height:auto;padding:10px 10px}\n", ""]);
// Exports
module.exports = exports;
